import { createContext } from 'react';

import { SyncConflict } from '@totem/components/administration/deviceSyncMerges/types';

interface Context {
  loading: boolean;
  conflicts: SyncConflict[];
  totalRecords: number;
  refetch: () => void;
}

const defaultContext: Context = {
  loading: false,
  conflicts: [],
  totalRecords: 0,
  refetch: () => {},
};

const DeviceSyncMergesContext = createContext<Context>(defaultContext);

export default DeviceSyncMergesContext;
